import React, { createContext, useContext, useState } from 'react';

const GstDiscountContext = createContext({
  discount: 0,
  gst: 0,
  discountType: 'percent',
  fixedDiscountAmount: 0,
  setDiscount: () => {},
  setGST: () => {},
  setDiscountType: () => {},
  setFixedDiscountAmount: () => {},
});

export const GstDiscountProvider = ({ children }) => {
  const [discount, setDiscount] = useState(0);
  const [gst, setGST] = useState(0);
  const [discountType, setDiscountType] = useState('percent');
  const [fixedDiscountAmount, setFixedDiscountAmount] = useState(0);

  return (
    <GstDiscountContext.Provider value={{
      discount, gst, discountType, fixedDiscountAmount,
      setDiscount, setGST, setDiscountType, setFixedDiscountAmount,
    }}>
      {children}
    </GstDiscountContext.Provider>
  );
};

export const useGstDiscount = () => {
  const context = useContext(GstDiscountContext);
  if (!context) {
    throw new Error('useGstDiscount must be used within a GstDiscountProvider');
  }
  return context;
};
